"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.arp = void 0;
var harmonics_1 = require("harmonics");
var utils_1 = require("./utils");
var DEFAULT_OCTAVE = 4;
/**
 * Take an array and fill it with it s own elements in the next octave till it s of the specified `len`
 * @param  {Array} arr e.g. ['a4', 'b4']
 * @param  {Number} e.g. len 4
 * @return {Array} e.g. ['a4', 'b4', 'a5', 'b5']
 */
var fillArr = function (arr, len) {
    var bumpOctave = function (el) {
        if (!el) {
            throw new Error('Empty element');
        }
        var note = el.replace(/\d/, '');
        var oct = el.replace(/\D/g, '') || DEFAULT_OCTAVE;
        if (!note) {
            throw new Error('Incorrect note');
        }
        return note + (+oct + 1);
    };
    // Create a couple of chord arrays with bumped octaves
    // so that something like [c3, e3, g4] turns into [c4, e4, g5] and [c5, e5, g6]
    var arr1 = arr.map(bumpOctave);
    var arr2 = arr1.map(bumpOctave);
    var finalArr = __spreadArray(__spreadArray(__spreadArray([], arr, true), arr1, true), arr2, true);
    // Slice and return only as much as required
    return finalArr.slice(0, len);
};
/**
 *
 * @param chordsOrParams a string that denotes space (comma?) separated chords to be used or an object with additional properties
 * By default, if this is a string, the count of notes generated is 8 and the order is ascending.
 * For instance arp('CM FM') will result in an array of notes [C4, E4, G4, F4, A4, C4, C5, E5]
 * You can even provide Params as an object.
 * For e.g. arp({count: 8, order: '10325476', chords: 'FM_4 Gm7b5_4 AbM_4 Bbm_4 Cm_5 DbM_5 EbM_5})
 */
var arp = function (chordsOrParams) {
    var finalArr = [];
    var params = {
        count: 4,
        order: '0123',
        chords: '',
    };
    if (typeof chordsOrParams === 'string') {
        params.chords = chordsOrParams;
    }
    else {
        if (chordsOrParams.order && chordsOrParams.order.match(/\D/g)) {
            throw new TypeError('Invalid value for order');
        }
        if (chordsOrParams.count > 8 || chordsOrParams.count < 2) {
            throw new TypeError('Invalid value for count');
        }
        // Provision a order for the notes in case only count was provided
        if (chordsOrParams.count && !chordsOrParams.order) {
            params.order = Array.from(Array(chordsOrParams.count).keys()).join('');
        }
        Object.assign(params, chordsOrParams);
    }
    // Chords can be passed as a string, e.g. 'CM_4 FM_4'
    // or as an array of notes arrays e.g. [['C3', 'E3', 'G3', 'B3'], ['F3', 'A3', 'C4', 'E4']]
    if (typeof params.chords === 'string') {
        var chordsArr = params.chords.split(' ');
        chordsArr.forEach(function (c, i) {
            try {
                var filledArr_1 = fillArr((0, harmonics_1.inlineChord)(c), params.count);
                // reorder the filledArr as per params.order
                var reorderedArr = params.order
                    .split('')
                    .map(function (idx) { return filledArr_1[idx]; });
                finalArr = __spreadArray(__spreadArray([], finalArr, true), reorderedArr, true);
            }
            catch (e) {
                throw new Error("Cannot decode chord " + (i + 1) + " \"" + c + "\" in given \"" + params.chords + "\"");
            }
        });
    }
    else if (Array.isArray(params.chords)) {
        params.chords.forEach(function (c, i) {
            try {
                var filledArr_2 = fillArr(c, params.count);
                // reorder the filledArr as per params.order
                var reorderedArr = params.order
                    .split('')
                    .map(function (idx) { return filledArr_2[idx]; });
                finalArr = __spreadArray(__spreadArray([], finalArr, true), reorderedArr, true);
            }
            catch (e) {
                throw new Error(((0, utils_1.errorHasMessage)(e) ? e.message : e) + " in chord " + (i + 1) + " \"" + c + "\"");
            }
        });
    }
    else {
        throw new TypeError('Invalid value for chords');
    }
    return finalArr;
};
exports.arp = arp;
